export default __webpack_public_path__ + "static/media/Workwear.fbcf7da0.png";